export default __webpack_public_path__ + "rotate.svg";